<template>
  <div class="ad-placement">
    <el-form :inline="true" size="small">
      <el-form-item label="分类">
        <el-select v-model="query.category" clearable placeholder="全部分类">
          <el-option
            v-for="item in categories"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" clearable placeholder="全部状态">
          <el-option label="启用" :value="1" />
          <el-option label="停用" :value="0" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search"
          >查询</el-button
        >
        <el-button
          v-has="'add'"
          type="primary"
          icon="el-icon-plus"
          :disabled="!categories.length"
          @click="openEditor()"
          >新增广告配置</el-button
        >
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" :data="rows" border>
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column label="分类" width="150">
        <template slot-scope="{ row }">{{
          categoryLabel(row.category)
        }}</template>
      </el-table-column>
      <el-table-column label="关联对象" min-width="220">
        <template slot-scope="{ row }">
          <span v-if="row.assemblyIds && row.assemblyIds.length"
            >组件 ID：{{ row.assemblyIds.join("、") }}</span
          >
          <span v-else-if="row.blockId">blockId：{{ row.blockId }}</span>
          <span v-else>{{ categoryLabel(row.category) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="adSlot"
        label="业务广告位 adSlot"
        min-width="200"
        show-overflow-tooltip
      />
      <el-table-column label="状态" width="90">
        <template slot-scope="{ row }"
          ><el-tag :type="row.status === 1 ? 'success' : 'info'">{{
            row.status === 1 ? "启用" : "停用"
          }}</el-tag></template
        >
      </el-table-column>
      <el-table-column label="更新时间" width="180">
        <template slot-scope="{ row }">{{
          formatTime(row.modifyTime)
        }}</template>
      </el-table-column>
      <el-table-column label="操作" width="190" fixed="right">
        <template slot-scope="{ row }">
          <el-button
            v-has="'edit'"
            type="text"
            :disabled="busyId === row.id"
            @click="openEditor(row)"
            >编辑</el-button
          >
          <el-button
            v-has="'onOff'"
            type="text"
            :disabled="busyId === row.id"
            @click="changeStatus(row)"
            >{{ row.status === 1 ? "停用" : "启用" }}</el-button
          >
          <el-button
            v-has="'delete'"
            type="text"
            :disabled="busyId === row.id"
            @click="remove(row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="query.page"
      :page-size="query.size"
      :total="total"
      layout="total, prev, pager, next"
      @current-change="changePage"
    />

    <el-dialog
      :title="form.id ? '编辑广告配置' : '新增广告配置'"
      :visible.sync="visible"
      width="640px"
      :close-on-click-modal="false"
      :close-on-press-escape="!saving"
      :show-close="!saving"
    >
      <el-form ref="editor" :model="form" :rules="rules" label-width="130px">
        <el-form-item label="分类" prop="category">
          <el-select
            v-model="form.category"
            :disabled="!!form.id || saving"
            placeholder="请选择分类"
            @change="categoryChanged"
          >
            <el-option
              v-for="item in categories"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="isComponent" label="关联组件" prop="assemblyIds">
          <el-select
            v-model="form.assemblyIds"
            multiple
            filterable
            :loading="optionsLoading"
            :disabled="saving || optionsFailed"
            placeholder="可选择多个组件"
            class="full-width"
          >
            <el-option
              v-for="item in assemblies"
              :key="item.assemblyId"
              :value="item.assemblyId"
              :label="`${item.assemblyName}（${item.assemblyId}）`"
            />
          </el-select>
          <div class="hint">广告配置同时作用于所选组件的全部引用页面。</div>
          <el-button v-if="optionsFailed" type="text" @click="loadAssemblies"
            >重新加载组件</el-button
          >
        </el-form-item>
        <el-form-item v-if="selectedCategory.blockId" label="关联 blockId">
          <el-input :value="selectedCategory.blockId" disabled />
        </el-form-item>
        <el-form-item label="业务广告位" prop="adSlot">
          <el-input
            v-model.trim="form.adSlot"
            maxlength="255"
            show-word-limit
            placeholder="请输入 adSlot"
            :disabled="saving"
          />
        </el-form-item>
        <el-form-item label="启用状态">
          <el-switch
            v-model="form.status"
            :active-value="1"
            :inactive-value="0"
            :disabled="saving"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button :disabled="saving" @click="visible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="saving"
          :disabled="optionsLoading || optionsFailed"
          @click="save"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { placementRequest } from "./api";

const emptyForm = () => ({
  id: 0,
  category: "",
  assemblyIds: [],
  adSlot: "",
  status: 0,
});

export default {
  name: "adPlacement",
  data() {
    return {
      categories: [],
      rows: [],
      total: 0,
      query: { page: 1, size: 20, category: "", status: "" },
      form: emptyForm(),
      assemblies: [],
      visible: false,
      loading: false,
      saving: false,
      optionsLoading: false,
      optionsFailed: false,
      optionRequest: 0,
      listRequest: 0,
      busyId: 0,
      rules: {
        category: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
        assemblyIds: [
          {
            type: "array",
            required: true,
            min: 1,
            message: "请至少选择一个组件",
            trigger: "change",
          },
        ],
        adSlot: [
          {
            required: true,
            whitespace: true,
            message: "请输入业务广告位 adSlot",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    isComponent() {
      return ["horizontal", "vertical"].includes(this.form.category);
    },
    selectedCategory() {
      return (
        this.categories.find((item) => item.value === this.form.category) || {}
      );
    },
  },
  async created() {
    try {
      this.categories = await placementRequest("categories");
    } catch (error) {
      this.$message.error("广告分类加载失败，请刷新页面重试");
    }
    this.loadList();
  },
  methods: {
    categoryLabel(value) {
      const item = this.categories.find((item) => item.value === value);
      return item ? item.label : value;
    },
    formatTime(value) {
      return value ? new Date(value).toLocaleString() : "";
    },
    search() {
      this.query.page = 1;
      this.loadList();
    },
    changePage(page) {
      this.query.page = page;
      this.loadList();
    },
    async loadList() {
      const requestID = ++this.listRequest;
      this.loading = true;
      try {
        const params = { ...this.query };
        if (params.status === "") delete params.status;
        const result = await placementRequest("list", params);
        if (requestID !== this.listRequest) return;
        this.rows = result.list || [];
        this.total = result.total;
      } catch (error) {
        this.$message.error("广告配置列表加载失败");
      } finally {
        if (requestID === this.listRequest) this.loading = false;
      }
    },
    openEditor(row) {
      this.form = row
        ? {
            id: row.id,
            category: row.category,
            assemblyIds: [...(row.assemblyIds || [])],
            adSlot: row.adSlot,
            status: row.status,
          }
        : emptyForm();
      this.visible = true;
      this.$nextTick(() => this.$refs.editor.clearValidate());
      this.loadAssemblies();
    },
    categoryChanged() {
      this.form.assemblyIds = [];
      this.$nextTick(() => this.$refs.editor.clearValidate());
      this.loadAssemblies();
    },
    async loadAssemblies() {
      const requestID = ++this.optionRequest;
      this.assemblies = [];
      this.optionsFailed = false;
      this.optionsLoading = false;
      if (!this.isComponent) return;
      this.optionsLoading = true;
      try {
        const options = await placementRequest("assemblyOptions", {
          category: this.form.category,
          configId: this.form.id,
        });
        if (requestID !== this.optionRequest) return;
        this.assemblies = options || [];
        // Keep unavailable historical bindings visible so they can be removed.
        this.form.assemblyIds.forEach((id) => {
          if (!this.assemblies.some((item) => item.assemblyId === id)) {
            this.assemblies.push({
              assemblyId: id,
              assemblyName: "已失效组件，请移除",
            });
          }
        });
      } catch (error) {
        if (requestID === this.optionRequest) this.optionsFailed = true;
      } finally {
        if (requestID === this.optionRequest) this.optionsLoading = false;
      }
    },
    async save() {
      if (this.saving) return;
      const valid = await this.$refs.editor.validate().catch(() => false);
      if (!valid) return;
      this.saving = true;
      try {
        await placementRequest("save", this.form);
        this.visible = false;
        this.$message.success("保存成功");
        await this.loadList();
      } catch (error) {
        /* The shared request handler displays server errors. */
      } finally {
        this.saving = false;
      }
    },
    async changeStatus(row) {
      const status = row.status === 1 ? 0 : 1;
      try {
        await this.$confirm(
          `确认${
            status ? "启用" : "停用"
          }该配置？将同时影响全部关联组件或场景。`,
          "提示",
        );
      } catch (error) {
        return;
      }
      this.busyId = row.id;
      try {
        await placementRequest("updateStatus", { id: row.id, status });
        this.$message.success("状态已更新");
        await this.loadList();
      } catch (error) {
        /* The shared request handler displays server errors. */
      } finally {
        this.busyId = 0;
      }
    },
    async remove(row) {
      try {
        await this.$confirm("确认删除该配置并解除全部关联？", "提示", {
          type: "warning",
        });
      } catch (error) {
        return;
      }
      this.busyId = row.id;
      try {
        await placementRequest("delete", { id: row.id });
        if (this.rows.length === 1 && this.query.page > 1) this.query.page--;
        this.$message.success("删除成功");
        await this.loadList();
      } catch (error) {
        /* The shared request handler displays server errors. */
      } finally {
        this.busyId = 0;
      }
    },
  },
};
</script>

<style scoped>
.ad-placement {
  padding: 16px;
}
.full-width {
  width: 100%;
}
.hint {
  color: #909399;
  font-size: 12px;
  line-height: 20px;
  margin-top: 6px;
}
.el-pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
